import {
  Bold,
  Italic,
  Strikethrough,
  Heading1,
  Heading2,
  List,
  ListOrdered,
  Undo,
  Redo
} from "lucide-react";
import { Button } from "antd";
import { useEditorState } from "@tiptap/react";
import { Fragment } from "react";

const buttons = [
  { activeName: "bold", command: "toggleBold", icon: Bold, title: "Bold" },
  {
    activeName: "italic",
    command: "toggleItalic",
    icon: Italic,
    title: "Italic"
  },
  {
    activeName: "strike",
    command: "toggleStrike",
    icon: Strikethrough,
    title: "Strikethrough",
    addDividerAfter: true
  },
  {
    activeName: "heading",
    command: "toggleHeading",
    icon: Heading1,
    title: "Heading 1",
    args: { level: 1 }
  },
  {
    activeName: "heading",
    command: "toggleHeading",
    icon: Heading2,
    title: "Heading 2",
    args: { level: 2 },
    addDividerAfter: true
  },
  {
    activeName: "bulletList",
    command: "toggleBulletList",
    icon: List,
    title: "Bullet List"
  },
  {
    activeName: "orderedList",
    command: "toggleOrderedList",
    icon: ListOrdered,
    title: "Numbered List",
    addDividerAfter: true
  },
  { activeName: "undo", command: "undo", icon: Undo, title: "Undo" },
  { activeName: "redo", command: "redo", icon: Redo, title: "Redo" }
];

export const MenuBar = ({ editor = null }) => {
  if (!editor) {
    return null;
  }

  useEditorState({
    editor,
    selector: ({ editor: current }) => ({
      from: current.state.selection.from,
      to: current.state.selection.to,
      storedMarks: current.state.storedMarks
    })
  });

  return (
    <div className="flex items-center space-x-2 p-2 bg-white rounded-md">
      {buttons.map(
        ({ activeName, command, icon: Icon, title, args, addDividerAfter }) => {
          let isAvailable = false;

          try {
            if (args) {
              isAvailable = editor.can().chain().focus()[command](args).run();
            } else {
              isAvailable = editor.can().chain().focus()[command]().run();
            }
          } catch (_) {}

          let isActive = !!activeName;

          if (args) {
            isActive = editor.isActive(activeName, args);
          } else {
            isActive = editor.isActive(activeName);
          }

          return (
            <Fragment key={title}>
              <Button
                type="text"
                size="small"
                title={title}
                disabled={!isAvailable || !editor.isEditable}
                className={`icon-button-${isActive ? "active" : "muted"}`}
                onClick={() => {
                  if (args) {
                    editor.chain().focus()[command](args).run();
                  } else {
                    editor.chain().focus()[command]().run();
                  }
                }}
              >
                <Icon className="icon-14" />
              </Button>
              {addDividerAfter && <div className="divider" />}
            </Fragment>
          );
        }
      )}
    </div>
  );
};

{
  /* <Button type="text" size="small" className="icon-button-muted">
              <Bold className="icon-14" />
            </Button>
            <Button type="text" size="small" className="icon-button-muted">
              <Italic className="icon-14" />
            </Button>
            <Button type="text" size="small" className="icon-button-muted">
              <Strikethrough className="icon-14" />
            </Button>
            <div className="divider" />
            <Button type="text" size="small" className="icon-button-muted">
              <Heading1 className="icon-14" />
            </Button>
            <Button type="text" size="small" className="icon-button-muted">
              <Heading2 className="icon-14" />
            </Button>
            <div className="divider" />
            <Button type="text" size="small" className="icon-button-muted">
              <List className="icon-14" />
            </Button>
            <Button type="text" size="small" className="icon-button-muted">
              <ListOrdered className="icon-14" />
            </Button>
            <div className="divider" />
            <Button type="text" size="small" className="icon-button-muted">
              <Undo className="icon-14" />
            </Button>
            <Button type="text" size="small" className="icon-button-muted">
              <Redo className="icon-14" />
            </Button> */
}
